//import { LicenseInfo } from '@mui/x-data-grid-pro';
import { LicenseInfo } from '@mui/x-license-pro';

LicenseInfo.setLicenseKey(
  '4c23b83bd38281b97beca585efb5375aTz01MzA0OSxFPTE2OTgyMzU5OTQ2NjksUz1wcm8sTE09cGVycGV0dWFsLEtWPTI='
);

